import { PROJECTS_SORT_OPTIONS } from "@components/projects/projects-sort-constants";
import { ProjectsSortField } from "@components/projects/projects-sort-types";
import { SortItem } from "@custom-types/sort-types";
import { FaroCoreApiSchemas, FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 * @returns true if the given field is a valid ProjectsSortField
 * @param field - The field to check
 */
export function isProjectsSortField(
  field: unknown
): field is ProjectsSortField {
  const validFields: string[] = Object.keys(PROJECTS_SORT_OPTIONS);
  return typeof field === "string" && validFields.includes(field);
}

/**
 * @returns Whether the value is a valid FaroCoreApiTypes.ProjectsSortBy
 * @param value Value to check
 */
export function isProjectsSortBy(
  value: unknown
): value is FaroCoreApiTypes.ProjectsSortBy {
  const validSortValues: string[] = Object.values(
    FaroCoreApiSchemas.projectsSortBySchema.enum
  );
  return typeof value === "string" && validSortValues.includes(value);
}

/**
 * @returns The projects SortBy value corresponding to the given SortItem
 * @param sortItem - The sort item to convert
 */
export function getProjectsSortBy(
  sortItem: SortItem<ProjectsSortField>
): FaroCoreApiTypes.ProjectsSortBy {
  const isAscending = sortItem.sort === "asc";
  switch (sortItem.field) {
    case "name":
      return isAscending ? "name_ascending" : "name_descending";
    case "lastUpdated":
      return isAscending ? "recently_modified_first" : "recently_modified_last";
    case "created":
      return isAscending ? "created_at_asc" : "created_at_desc";
    case "size":
      return isAscending ? "storage_asc" : "storage_desc";
    case "lastCaptured":
      return isAscending ? "last_captured_at_asc" : "last_captured_at_desc";
    default: {
      // Enforce exhaustiveness
      sortItem.field satisfies never;
      return "recently_modified_first";
    }
  }
}
